import kebabCase from 'lodash/kebabCase';

export const applicationTypes = {
  FERTILIZER: 'fertilizer',
  SEED: 'seed',
  STABILIZER: 'stabilizer',
  APPLICATION: 'application',
  APPLICATIONV2: 'APPLICATION_v2'
} as const;

export const scriptTypes = {
  FERTILITY: 'fertility',
  PLANTING: 'planting',
  APPLICATION: 'application', // Also referred to as "Crop Protection"
  EXPERIMENT: 'experiment'
};

export const applicationSubTypes = {
  HERBICIDE: 'herbicide',
  INSECTICIDE: 'insecticide',
  FUNGICIDE: 'fungicide',
  GROWTHREGULATOR: 'growthregulator',
  MIX: 'mix'
};

export const applicationScriptTypePrefix = 'manual-application-';

export const applicationScriptTypes = [
  'FUNGICIDE',
  'HERBICIDE',
  'INSECTICIDE',
  'GROWTH_REGULATOR'// TODO: or GROWTH-REGULATOR
].reduce((result, key) => { result[key] = `${applicationScriptTypePrefix}${key.toLowerCase()}`; return result; }, {});

export const fertilityScriptTypePrefix = 'manual-fertility-';

export const fertilityScriptTypes = [
  'LIME',
  'OTHER',
  'NITROGEN',
  'PHOSPHORUS',
  'POTASSIUM'
].reduce((result, key) => { result[key] = `${fertilityScriptTypePrefix}${key.toLowerCase()}`; return result; }, {});

export const scriptMethods = {
  ADVANCED: 'advanced',
  MANUAL: 'manual'
};

export const managementZonesTypes = {
  FERTILITY: 'fertility',
  FIELD_BOUNDARY: 'field-boundary',
  PLANTING: 'planting',
  APPLICATION: 'application',
  SSURGO: 'ssurgo',
  IMPORTED_MAPS: 'imported-maps',
  GENERATE_ZONES: 'generate-zones',
  PREVIOUS_PRESCRIPTION: 'previous-prescription',
  IMPORTED_MAPS_PARENT: 'imported-maps-parent'
} as const;

export const applicationProperties = [
  'PRODUCT',
  'TARGET_YIELD',
  `RATE`,
  `NITROGEN_RATE`,
  `${applicationTypes.APPLICATION}_RATE`,
  `${applicationTypes.FERTILIZER}_RATE`,
  `${applicationTypes.SEED}_RATE`
].reduce(
  (result, key) => { result[key.toUpperCase()] = `${kebabCase(key)}`; return result; },
  // TODO: Move other properties to camelCase, update load/save
  { INCORPORATION_METHOD: 'incorporationMethod' }
);

export const editZoneTypes = [
  'ADD_ZONE',
  'MERGE',
  'SPLIT'
].reduce((result, key) => { result[key] = `${kebabCase(key)}`; return result; }, {});

export const editZoneReturnTypes = [
  'LOG',
  'LOG_ERROR'
].reduce((result, key) => { result[key] = `${kebabCase(key)}`; return result; }, {});

export const allowedZoneGenerationLayers = [
  'scouting'
];
